//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapMutations, mapActions } from "vuex";
import Loader from "./transitions/Loader.vue";
import PageLogin from "./components/PageLogin.vue";
import PageResetPassword from "./components/PageResetPassword.vue";
import PageOptional from "./components/PageOptional.vue";
import PageRegistration from "./components/PageRegistration.vue";
import PageDashboard from "./components/PageDashboard.vue";
export default {
  name: "FlyoutRegistration",
  components: {
    Loader,
    PageLogin,
    PageResetPassword,
    PageOptional,
    PageRegistration,
    PageDashboard
  },
  data() {
    return {
      isLoggedIn: this.$parent.loggedIn,
      startRegistration: this.$parent.registration
    };
  },
  computed: {
		...mapGetters(["isLoaded", "isLoading", "isResetPassword", "isAuthenticated", "isAccountExist", "isOptionalQuestions", "isOptionalEmail", "isDisabled", "isLoading", "isRedirect", "optionalQuestionsDismissed"])
	},
	methods: {
		...mapMutations(["setRegistrationPage", "setDisabled", "setError","setData", "setLoaded", "setLoading", "setAccountExist", "setAuthenticated", "setRedirect", "setStateValue"]),
		...mapActions(["getData","getAccountInfo","getAccountCookies"]),
    closeFlyout() {
      if(this.isRedirect && this.isAuthenticated && this.isAccountExist) {
        window.location.replace(this.isRedirect)
      } else if(this.isLoggedIn === "false" && this.isAuthenticated && this.isAccountExist) {
        window.location.replace(window.location.href)
      }
      this.$el.parentElement.classList.toggle('is-active')
      document.body.classList.remove('login-is-active')
    }
  },
  created() {
    if(this.startRegistration) {
      this.setRegistrationPage(true)
      this.setError(false)
      this.setDisabled(false)
      this.setRedirect(window.location.href)
    } else if(this.isLoggedIn === "true") {
      this.setAccountExist(true)
      this.setAuthenticated(true)
    } else {
      setTimeout(() => {
        this.setLoading(false)
      }, 500);
    }
		let optionalQuestionsDismissed = !!localStorage.getItem('optionalQuestionsDismissed');
		this.setStateValue(['optionalQuestionsDismissed', optionalQuestionsDismissed]);
  },
  mounted() {
    const ref = this;
    // Constructing a url for forbidden content pages
    if(window.location.search.length > 0) {
      const params = new URLSearchParams(window.location.search)
      if(params.has('ReturnUrl')) {
        let returnUrl = params.get('ReturnUrl')
        if(returnUrl.charAt( 0 ) === '/') {
          returnUrl = returnUrl.slice(1)
        }
        this.setRedirect(`${window.location.origin}/${returnUrl}`)
      }
    }
    
    if(this.startRegistration) {
      const loginAnchor = document.querySelector('.header-profile')
      loginAnchor.click()
    }

    function checkFocus() {
      requestAnimationFrame(checkFocus);

      if (ref.$el.parentElement.classList.contains('is-active')) {
        if (!ref.$el.contains(document.activeElement))
          document.querySelector('.registration-flyout__logo').focus();
      }
    }
    checkFocus();
  }
};
